var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var SnapSet = require("../snap/snapSet");
var AbstractSelectableInteractionModel = require("../../abstract/abstractSelectableInteractionModel.js");
var cio_config = require("cio-config");

var OriginInteractionModel = function(originModel) {
    AbstractSelectableInteractionModel.call(this, {});
    this.originModel = originModel;
};
lib_core.inherit(OriginInteractionModel, AbstractSelectableInteractionModel);
lib_core.JsonParser.registerClass(OriginInteractionModel, "OriginInteractionModel");

module.exports = OriginInteractionModel;

OriginInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = {
        input_elements: []
    };

    if(this.originModel.units.length > 1){
        inspectorElements.input_elements.push({
            label       : 'Pitch',
            type        : ui_extensions.InspectorInputType.VALUE_AND_UNIT,
            datamember  : this.originModel.grid_value,
            datatype    : cio_config.types.positive_float,
            unitmember  : this.originModel.grid_unit,
            allowed_units : this.originModel.units

        });
    } else {
        inspectorElements.input_elements.push({
            label      : 'Pitch',
            type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember : this.originModel.grid_value,
            datatype    : cio_config.types.positive_float,
            unitmember  : this.originModel.showUnitString
        });
    }

    inspectorElements.input_elements.push({
        label       : 'Show grid',
        type        : ui_extensions.InspectorInputType.CHECKBOX,
        datamember  : this.originModel.grid_show
    });

    inspectorElements.help_elements = {
        'name':            'Grid',
        'usage':           'Show or hide the grid by clicking the grid button in the toolbar.<br><br>Snapping is enabled when the grid is visible and disabled when hidden.<br><br>Changing the unit in the dropdown will recalculate the number. The default unit can be changed in the circuit settings.'
    };

    return inspectorElements;
};

OriginInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new SnapSet();
    return snapSet;
};
